import { forwardRef } from 'react';
import { Input as RSuiteInput } from 'rsuite';
import './index.css';

const Input = forwardRef(({ autoComplete = "new-password", ...props }, ref) => {
  return (
    <div className="input-wrapper">
      <RSuiteInput {...props} ref={ref} autoComplete={autoComplete} />
    </div>
  );
});
export default Input;
